import { Client } from './../../../../models/client';
import { DataTableHelpers } from './../../../../components/system/datatable/datatable-helper';
import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import {
  ItemSearchOptionField,
  ItemSearchFilter,
  ItemSearchOption,
  ItemSearchOptionFieldOption
} from 'src/app/components/filter-list/models/filterClasses';
import { WorkflowContextService } from 'src/app/services';
import { InspectionQueueComponent } from 'src/app/components/inspections/inspection-queue/inspection-queue.component';
import { ComponentIds } from 'src/app/models/component-ids';

@Component({
    selector: 'app-my-inspection-queue-complete',
    templateUrl: './my-inspection-queue-complete.component.html',
    styles: [],
    standalone: false
})
export class MyInspectionQueueCompleteComponent implements OnInit {
  @Output() dataLoaded = new EventEmitter<string>();
  @Output() updateStatus = new EventEmitter();
  @Output() recordCountSet = new EventEmitter<number>();
  @Output() filtersChanged = new EventEmitter<boolean>();
  @Input() client: Client;

  @ViewChild('wmInspectionQueue', { static: false })
  wmInspectionQueue: InspectionQueueComponent;

  id = ComponentIds.MY_INSPECTION_QUEUE_COMPLETE;

  public columns = [
    {
      prop: 'address',
      name: 'Address'
    },
    {
      prop: 'city',
      name: 'City'
    },
    { prop: 'inspectionType', 
      name: 'Inspection Type' 
    },
    {
      prop: 'scheduledOn',
      name: 'Scheduled Time',
      pipe: this.dtHelpers.getDatePipe('MM/dd/yyy, h:mm a')
    },
    {
      prop: 'inspectorName',
      name: 'Assigned Inspector'
    },
    { prop: 'requestorName', 
      name: 'Requestor Name' 
    },
    { 
      prop: 'requestorPhoneNumber', 
      name: 'Requestor Phone' 
    },
    {
      prop: 'inspectionStatus',
      name: 'Status'
    }
  ];

  staticFilters: ItemSearchFilter;

  constructor(
    private context: WorkflowContextService,
    private dtHelpers: DataTableHelpers
  ) {}

  reload() {
    this.wmInspectionQueue.loadInspections().subscribe(z => {
      this.wmInspectionQueue.inspectionRequests = z;
    });
  }

  ngOnInit() {
    this.staticFilters = new ItemSearchFilter({
      options: [
        new ItemSearchOption({
          field: new ItemSearchOptionField({
            title: 'CanPerformAction',
            options: [
              new ItemSearchOptionFieldOption({
                title: 'CanPerformAction',
                selected: true,
                filterText: '',
                searchText: 'completeActivity',
                strOperator: ''
              })
            ]
          })
        })
      ]
    });
  }

  updateStatusEvent(evt) {
    this.updateStatus.emit(evt);
  }

  emitDataLoaded() {
    this.dataLoaded.emit('MyInspectionQueueCompleteComponent');
  }

  setRecordCount(count: number) {
    this.recordCountSet.emit(count);
  }

  filtersChange() {
    this.filtersChanged.emit(true);
  }
}
